var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3714_54207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7445 8.07129H14.3695V8.82129H14.7445V8.07129ZM15.5693 8.82129C15.7764 8.82129 15.9443 8.6534 15.9443 8.44629C15.9443 8.23918 15.7764 8.07129 15.5693 8.07129V8.82129ZM14.7445 8.82129H15.5693V8.07129H14.7445V8.82129Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25539 8.07129H1.63039V8.82129H1.25539V8.07129ZM0.430606 8.82129C0.223499 8.82129 0.0556058 8.6534 0.0556058 8.44629C0.0556058 8.23918 0.223499 8.07129 0.430606 8.07129V8.82129ZM1.25539 8.82129H0.430606V8.07129H1.25539V8.82129Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37524 15.1904L8.37524 14.8154L7.62524 14.8154L7.62524 15.1904L8.37524 15.1904ZM7.62524 16.0152C7.62524 16.2223 7.79314 16.3902 8.00024 16.3902C8.20735 16.3902 8.37524 16.2223 8.37524 16.0152L7.62524 16.0152ZM7.62524 15.1904L7.62524 16.0152L8.37524 16.0152L8.37524 15.1904L7.62524 15.1904Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37537 1.70168L8.37537 2.07668L7.62537 2.07668L7.62537 1.70168L8.37537 1.70168ZM7.62537 0.876895C7.62537 0.669788 7.79326 0.501895 8.00037 0.501895C8.20747 0.501895 8.37537 0.669788 8.37537 0.876895L7.62537 0.876895ZM7.62537 1.70168L7.62537 0.876895L8.37537 0.876895L8.37537 1.70168L7.62537 1.70168Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 12.8747C10.4454 12.8747 12.4277 10.8924 12.4277 8.4471C12.4277 6.00182 10.4454 4.01953 8.00008 4.01953C5.5548 4.01953 3.57251 6.00182 3.57251 8.4471C3.57251 10.8924 5.5548 12.8747 8.00008 12.8747ZM5.97404 10.197L8.02362 5.58547L10.0732 10.197L8.02362 9.13277L5.97404 10.197Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00031 14.3898C11.2824 14.3898 13.943 11.7291 13.943 8.44708C13.943 5.16503 11.2824 2.50439 8.00031 2.50439C4.71825 2.50439 2.05762 5.16503 2.05762 8.44708C2.05762 11.7291 4.71825 14.3898 8.00031 14.3898ZM7.97576 13.6154C10.8312 13.6154 13.146 11.3006 13.146 8.4451C13.146 5.58965 10.8312 3.27484 7.97576 3.27484C5.1203 3.27484 2.8055 5.58965 2.8055 8.4451C2.8055 11.3006 5.1203 13.6154 7.97576 13.6154Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3714_54207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.446289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracker);
export default __webpack_public_path__ + "static/media/tracker.960c3fed3b28b2921c7510e33fd8a741.svg";
export { ForwardRef as ReactComponent };